import { Construction } from 'lucide-react';
import { Panel } from '@/components/Panel';

/** Page pas encore implémentée : remplacée au fur et à mesure par les écrans du prototype */
export function PlaceholderPage() {
  return (
    <Panel className="p-12 flex flex-col items-center text-center text-slate-500">
      <Construction className="w-10 h-10 text-slate-300 mb-4" />
      <p>Page en cours de construction</p>
    </Panel>
  );
}
